package com.milta.core.localization.translations.es

import com.milta.core.localization.SettingsStrings

internal val Settings = SettingsStrings(
    profileSectionTitle = "PERFIL DE LA ORGANIZACIÓN",
    profileNameLabel = "Nombre de la organización",
    languageSectionTitle = "IDIOMA DE LA INTERFAZ",
    languageSearchPlaceholder = "Buscar un idioma...",
    languageMoreAvailable = "%d idiomas más disponibles",
    languageErrorGeneric = "Se produjo un error. Inténtalo de nuevo.",
    subscriptionSectionTitle = "SUSCRIPCIÓN",
    subscriptionPlanLabel = "Plan",
    subscriptionBillingLabel = "Facturación",
    subscriptionRenewalLabel = "Próxima renovación",
    subscriptionBillingMonthly = "Mensual",
    subscriptionBillingAnnual = "Anual",
    subscriptionPlanOrganisationLabel = "Organización (Gerente + equipo)",
    subscriptionPriceSuffix = "IVA excl. / mes",
    subscriptionUnavailable = "No disponible",
    deleteSectionTitle = "Eliminar la organización",
    deleteWarning = "Esta acción es permanente e irreversible.",
    deleteDescription = "Las rutas y los comprobantes de entrega se eliminarán. Las cuentas de los conductores se desvincularán de la organización, pero nunca se eliminarán.",
    deleteConfirmLabel = "Para confirmar, introduce el nombre de la organización",
    deleteButton = "Eliminar definitivamente",
    deleteFinalDialogTitle = "¿Confirmar la eliminación definitiva?",
    deleteFinalDialogMessage = "Esta acción no se puede deshacer. La organización, sus rutas y comprobantes de entrega se eliminarán definitivamente.",
    deleteErrorGeneric = "Se produjo un error. Inténtalo de nuevo.",
    legalSectionTitle = "AVISOS LEGALES",
    legalTermsLabel = "Condiciones de uso",
    legalPrivacyLabel = "Privacidad y RGPD",
)
